import React from 'react';
// import Wrp from '../../../hoc/Wrp/Wrp';
//import Modal from "react-bootstrap/Modal";
// import Inputs from '../../../Components/Inputs/Inputs';
import DropDownSearch from '../../../Components/DropDownSearch';
import Modal from '../../../Components/UI/Modal';

const AssignWindow = (props) => {
    const fieldDetail = JSON.parse(props.formData);
    // console.log(fieldDetail);

    const buttonList = [
        {
            name:'Cancel',
            clickHandler:() => props.toggleModelHandlerWindow('yes'),
            attributes:{
                className:'btn btn-cancel',
                'data-dismiss':"modal"
            }
        },
        {
            name:'Continue',
            clickHandler:props.createTemplateHandler,
            attributes:{
                className:'btn primary_bg'
            }
        }
        
    ];

    return(
        <Modal title="Choose the Window" modalDim={'modal-md'} buttonList={buttonList} isModalOpen={props.modelOpenWindow}>
            <>
                <div className="row">
                    <div className="col-12">
                        <div className="form-group">
                            <label className="name-specification">Select Window</label>
                            {/*<select className={'form-control mandatory select2'} name="window_name" onChange={props.addDataHandler} value={fieldDetail.window_name.value}>
                            {
                                fieldDetail.window_name.options ?
                                    fieldDetail.window_name.options.map((arr,i) => {
                                        return <option key={i} windowname={arr.windowName} value={arr.value}>{arr.name}</option>
                                    })
                                : null
                            }
                            </select>  */}
                            <div className='select2-arrow'>
                                <DropDownSearch
                                    options={fieldDetail.window_name.options}
                                    values={fieldDetail.window_name.value}
                                    changeHandler={e=>props.select2DataHandler(e,"window_name",fieldDetail.window_name.options)}
                                />
                            </div>
                            {fieldDetail.window_name.error !== "" ? 
                                <label className="error m-0">{fieldDetail.window_name.error}</label>
                                : null
                            }
                        </div> 
                    </div>
                </div>    
            </>
        </Modal>

        // <Modal dialogClassName="modal-dialog modal-sm " show={props.modelOpenWindow} onHide={props.toggleModelHandlerWindow}>
        //     <Modal.Header>
        //         <h5 className="modal-title secondary_color" id="staticModalLabel"> Choose the Window </h5>   
        //     </Modal.Header>
        //     <Modal.Body>
                     
        //     </Modal.Body>
        //     <Modal.Footer>
        //     <button onClick={props.createTemplateHandler} type="button" className="btn primary_bg btn custom-toggle4" data-dismiss="modal"> Continue </button>
        //     <button onClick={e=> props.toggleModelHandlerWindow('yes')} type="button" className="btn border-default btn-border mr-1" data-dismiss="modal">Cancel</button>    
        //     </Modal.Footer>
        // </Modal>
      
    )

}

export default AssignWindow;